export default {
  componentName: 'historical-stats',
  exampleImgUrl:
    'https://drive.google.com/open?id=1kbFR7ZfSfMM36QbRDLmY3cOQhhWnGTjW',
  nickname: 'historical-stats',
  pageList: ['https://www.bassmaster.com/anglers/bobby-lane'],
  renderId: 'react-app--historical-stats',
};
